import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import Modal from '@blaze-react/modal';
import VideoRender from './VideoRender';
const VideoModal = _ref => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  const [displayModal, setDisplayModal] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "button",
    "aria-label": "Open video",
    onClick: () => {
      setDisplayModal(!displayModal);
    }
  }, /*#__PURE__*/React.createElement(VideoRender, _extends({
    placeholderOnly: true,
    autoplay: false
  }, props))), displayModal && /*#__PURE__*/React.createElement(Modal, {
    className: "modal--video",
    isFullScreen: true,
    showFooter: false,
    isSimple: true,
    onClose: () => setDisplayModal(!displayModal)
  }, /*#__PURE__*/React.createElement(VideoRender, _extends({}, props, {
    placeholderOnly: false,
    autoplay: true
  }))));
};
export default VideoModal;
//# sourceMappingURL=VideoModal.js.map